import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import styles from "./BuyAdminThemeToggle.module.css";
import "./buyAdminThemeGlobals.css";
import { useBuyAdminTheme } from "./useBuyAdminTheme";

type BuyAdminThemeToggleProps = {
  className?: string;
  /** When true, show only the sun/moon icon (Sell-side style). */
  iconOnly?: boolean;
};

const BuyAdminThemeToggle = ({ className = "", iconOnly = true }: BuyAdminThemeToggleProps) => {
  const { isDarkMode, toggleTheme } = useBuyAdminTheme();

  return (
    <button
      type="button"
      className={`${styles.toggle} ${iconOnly ? styles.iconOnly : ""} ${className}`.trim()}
      onClick={toggleTheme}
      aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
      title={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDarkMode ? <LightModeOutlinedIcon fontSize="small" /> : <DarkModeOutlinedIcon fontSize="small" />}
      {!iconOnly ? <span className={styles.label}>{isDarkMode ? "Light" : "Dark"}</span> : null}
    </button>
  );
};

export default BuyAdminThemeToggle;
